module.exports = __webpack_public_path__ + "static/img/04weiqu.093c4c41.gif";